import axios from 'axios';
import { config } from '../config';

const API_URL = config.BACKEND_URL;

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Get all special service options
export const getAllOptions = async (activeOnly = false) => {
  try {
    const response = await api.get(`/api/special-service-options`, {
      params: { activeOnly }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching special service options:', error);
    throw error;
  }
};

// Get single option by ID
export const getOptionById = async (id) => {
  try {
    const response = await api.get(`/api/special-service-options/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching special service option:', error);
    throw error;
  }
};

// Create new option (Editor and Admin only)
export const createOption = async (optionData) => {
  try {
    const response = await api.post('/api/special-service-options', optionData);
    return response.data;
  } catch (error) {
    console.error('Error creating special service option:', error);
    throw error;
  }
};

// Update option (Editor and Admin only)
export const updateOption = async (id, optionData) => {
  try {
    const response = await api.put(`/api/special-service-options/${id}`, optionData);
    return response.data;
  } catch (error) {
    console.error('Error updating special service option:', error);
    throw error;
  }
};

// Delete option (Editor and Admin only)
export const deleteOption = async (id) => {
  try {
    const response = await api.delete(`/api/special-service-options/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting special service option:', error);
    throw error;
  }
};

// Toggle active status (Editor and Admin only)
export const toggleActiveStatus = async (id) => {
  try {
    const response = await api.put(`/api/special-service-options/${id}/toggle-active`);
    return response.data;
  } catch (error) {
    console.error('Error toggling special service option status:', error);
    throw error;
  }
};

export default {
  getAllOptions,
  getOptionById,
  createOption,
  updateOption,
  deleteOption,
  toggleActiveStatus
};
